import { useTranslation } from 'react-i18next';
import { useLang } from '@/hooks/useLang';

const cards = [
  {
    key: 'spreadsheet',
    icon: 'ri-table-line',
    href: '/allchinabuy-spreadsheet/',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20colorful%20data%20spreadsheet%20on%20minimal%20white%20desk%20with%20warm%20natural%20light%20productivity%20photography%20no%20text%20no%20brands&width=600&height=400&seq=val-spreadsheet-01&orientation=landscape',
  },
  {
    key: 'seller',
    icon: 'ri-user-search-line',
    href: '/allchinabuy-safety-guide/',
    image: 'https://readdy.ai/api/search-image?query=Professional%20handshake%20in%20modern%20glass%20office%20with%20city%20view%20blurred%20background%20business%20photography%20warm%20tones%20no%20text%20no%20brands&width=600&height=400&seq=val-seller-01&orientation=landscape',
  },
  {
    key: 'qc',
    icon: 'ri-camera-lens-line',
    href: '/allchinabuy-qc-guide/',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20fabric%20texture%20detail%20on%20textile%20with%20warm%20side%20lighting%20quality%20control%20product%20photography%20no%20text%20no%20brands&width=600&height=400&seq=val-qc-01&orientation=landscape',
  },
  {
    key: 'shipping',
    icon: 'ri-truck-line',
    href: '/allchinabuy-shipping/',
    image: 'https://readdy.ai/api/search-image?query=Small%20globe%20model%20next%20to%20parcel%20box%20on%20wooden%20desk%20with%20warm%20ambient%20light%20global%20logistics%20concept%20photography%20no%20text%20no%20brands&width=600&height=400&seq=val-shipping-01&orientation=landscape',
  },
  {
    key: 'reviews',
    icon: 'ri-star-line',
    href: '/allchinabuy-review/',
    image: 'https://readdy.ai/api/search-image?query=Five%20star%20rating%20cards%20and%20customer%20review%20notes%20pinned%20on%20cork%20board%20with%20warm%20lighting%20business%20concept%20photography%20no%20text%20no%20brands&width=600&height=400&seq=val-reviews-01&orientation=landscape',
  },
  {
    key: 'safety',
    icon: 'ri-shield-check-line',
    href: '/allchinabuy-legit/',
    image: 'https://readdy.ai/api/search-image?query=Shield%20security%20icon%20on%20frosted%20glass%20panel%20with%20warm%20backlight%20protection%20concept%20minimal%20photography%20no%20text%20no%20brands&width=600&height=400&seq=val-safety-01&orientation=landscape',
  },
];

export default function ValueSection() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14 max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
            {t('value.h2')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('value.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.key}
              href={`/${lang}${card.href}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300/60 transition-all hover:-translate-y-0.5"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={t(`value.cards.${card.key}.title`)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${card.icon} text-lg md:text-xl`} />
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
                  {t(`value.cards.${card.key}.title`)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(`value.cards.${card.key}.desc`)}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  <span>{t('common.learnMore')}</span>
                  <i className="ri-arrow-right-line" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}